export default {
  users: {
    results: [],
  },
  single_user: {},
  roles: {
    results: [],
  },
  permissions: [],
}
